

import { defineComponent } from 'vue';
import { NInput } from 'naive-ui';

import modalBase from './modal-base';

export default defineComponent({

    extends: modalBase,

    components: {
        NInput,
    },

    data() {
        return {
            title: '',
            promptValue: null,
            valid: true,
        }
    },

    mounted(): void {
        this.$eventBus.on('prompt.open', (options: { title: string}) => {
            this.title = options.title;
            this.open();
        })
    },

    methods: {
        submit(): void {

            if(!this.promptValue) {
                return;
            }

            this.$eventBus.emit('prompt.submit', this.promptValue);
            this.promptValue = null;
            this.close(true);
        },

        onClosed(): void {
            this.$eventBus.emit('prompt.close')
        }
    },
});
